export enum PromotionalFreeSpinsActions {
    SKIP = 'skip',
    DELETE = 'delete',
    CONTINUE = 'continue'
}
